<template>
  <b-container fluid class="mb-3">

    <!--        <pre style="max-height: 200px; overflow-y: scroll;">-->
    <!--          {{ company }}-->
    <!--          {{ getActiveCompany }}-->
    <!--        </pre>-->

    <b-row class="mb-3">
      <b-col cols="12" v-if="!!getActiveCompany">
        <PageHeader
            header-icon="fas fa-chevron-down"
            :title="getActiveCompany.shortName"
            header-link="/app/companies"
        />
      </b-col>
    </b-row>


    <owner-identification/>

    <b-row class="">
      <b-col cols="12" lg="6" class="mb-md-4 mb-lg-0">
        <b-card class="h-100">
          <template v-slot:header>
            <b-container fluid>
              <b-row>
                <b-col cols="12">
                  <div class="d-flex justify-content-between">
                    <div class="vertical-center ml-0 mr-0 width-max-content">
                      <div class="mb-0 custom-card-header-text">
                        {{ $cte("home.myTask") }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </template>
          <div class="h-100 d-flex flex-column justify-content-between">
            <div class="home-view-container">
              <TaskView
                  :apiLoading="apiLoadingTask"
                  :tasks="tasks.content"
                  :item-per-page="myTaskOptions.itemPerPage"
                  :api-callback="myTaskOptions.apiCallback"
                  :enable-pagination="myTaskOptions.enablePagination"
                  :display-prop="myTaskOptions.displayProp"
                  :detail-view="myTaskOptions.detailView"
                  :back-router-link="myTaskOptions.backRouterLink"
                  :key="forceUpdateKey"
              />
            </div>
            <div class="d-flex ml-0 mr-0 width-max-content ml-auto">
              <router-link :to="{ path: '/app/tasks'}">
                <b-button variant="primary" size="sm" class="button-max-content mt-3">
                  <span class="d-inline-block ml-2 mt-1">További feladataim</span>
                </b-button>
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" lg="6" class="mb-md-4 mb-lg-0">
        <div class="my-3 my-md-0">
          <b-card class="h-100">
            <template v-slot:header>
              <b-container fluid>
                <b-row>
                  <b-col cols="12">
                    <div class="d-flex justify-content-between">
                      <div class="vertical-center ml-0 mr-0 width-max-content">
                        <div class="mb-0 custom-card-header-text">
                          Kérdéseim
                        </div>
                      </div>
                      <div class="vertical-center ml-0 mr-0 _width-max-content">
                        <b-button variant="light"
                                  class="new-ticket-button"
                                  @click="newTicket">
                          <i class="fas fa-plus"></i>
                        </b-button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </template>

            <div class="h-100 d-flex flex-column justify-content-between">
              <div class="home-view-container">
                <TicketView
                    :tickets="tickets.content"
                    :apiLoading="apiLoadingTicket"
                    :key="forceUpdateKey"
                />
              </div>
              <div class="d-flex ml-0 mr-0 width-max-content ml-auto">
                <router-link :to="{ path: '/app/tickets'}">
                  <b-button variant="primary" size="sm" class="button-max-content mt-3">
                    <span class="d-inline-block ml-2 mt-1">További kérdéseim</span>
                  </b-button>
                </router-link>
              </div>
            </div>

          </b-card>
        </div>
      </b-col>
    </b-row>


    <b-card v-if="!hasNavConnection" style="background-color: #252734; color: #b2ec5d" class="shadow-lg p-3 mb-3 mt-3">
      <div>
        <p class="">Kérjük kösd össze Acounto fiókod a NAV Online számla rendszerével az Elemzések
          eléréséhez.</p>
        <p>Ehhez segítséget <a href="https://acounto.com/nav-onlineszamla/" target="_blank"
                               class="btn btn-success">itt</a> találsz.</p>
      </div>
    </b-card>


    <b-row v-if="hasNavConnection" class="mt-lg-4 font-jumper">
      <b-col cols="12">


          <!--
                    HIDE ha
                    taxForm="teteles VAGY kata"
                    ES
                    taxFrequency="nem afas"

          -->

          <b-card
              v-if="company.taxForms.length === 0 || !((company.taxForms[0].form === 'TETELES_ADOZO' || company.taxForms[0].form === 'KATA') && company.taxFrequencies[0].type === 'NON_TAX')"
          >
            <!--                        <b-card>-->


            <div>
              <b-row>
                <b-col>
                  <h4 class="mb-4">Elemzések</h4>
                </b-col>
              </b-row>

                <b-tabs content-class="mt-3" v-model="selectedTab" class="reports">
                  <b-tab :title="$cte('vat.atalany')"
                         @click="selectedVatOption = atalanyOption; updateActiveTabId('my-custom-id-atalany')"
                         v-b-toggle="'my-custom-id-atalany'"
                         v-if="isEvStatus"
                         lazy
                  >
                    <!--                    atalanyado kalkulacio-->
                    <AtalanyView/>
                  </b-tab>

                  <!--               ha a ceg atalanyadozo, csak akkor kell a keret tab
                                     v-if="isEvTaxation(getActiveCompany)"
                  -->
                  <b-tab :title="$cte('vat.annualLimit')"
                         @click="selectedVatOption = atalanyOption; updateActiveTabId('my-custom-id-atalany')"
                         v-b-toggle="'my-custom-id-annualLimit'"
                         v-if="annualLimitTabIsShow(company)"
                         lazy
                  >
                    <!--                    eves keret-->
                    <AnnualLimit />
                  </b-tab>
                  <b-tab title="ÁFA"
                         v-b-toggle="'my-custom-id-vat'"
                         v-if="checkVat()"
                         :mode="'vat'"
                         @click="updateActiveTabId('my-custom-id-vat')"
                         lazy
                  >
                    <!--                    afa-->
                    <VatView
                        ref="vat-view"
                        :vat-option="selectedVatOption"
                        :mode="'vat'"
                        @validate="(valid) => { vatViewEnabled = valid; }"
                    />
                  </b-tab>
                  <b-tab title="Forgalom"
                         v-b-toggle="'my-custom-id-sumExcludedVat'"
                         v-if="checkVat()"
                         @click="updateActiveTabId('my-custom-id-sumExcludedVat')"
                         lazy
                  >
                    <!--                    forgalom-->
                    <VatView
                        ref="vat-view"
                        :vat-option="selectedVatOption"
                        :mode="'transactions'"
                        @validate="(valid) => { vatViewEnabled = valid; }"
                    />
                  </b-tab>
                  <b-tab :title="$cte('vat.atalanyPaid')"
                         @click="selectedVatOption = atalanyOption; updateActiveTabId('my-custom-id-atalany')"
                         v-b-toggle="'my-custom-id-atalany'"
                         v-if="isEvStatus"
                         lazy
                  >
                    <!--                    atalanyado befizetesek-->
                    <AltalanyPaidView/>
                  </b-tab>
                </b-tabs>


            </div>
          </b-card>

      </b-col>
    </b-row>
    <new-ticket-modal
        title="Új kérdés"
        :show.sync="showNewTicketModal"
    />
  </b-container>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Api from "api-client/index";
import {mapGetters} from "vuex";
import TaskView from "@/components/TaskView";
import VatView from "@/components/VatView";
import AtalanyView from "@/views/app/invoicing/AtalanyView";
import AnnualLimit from "@/views/app/invoicing/AnnualLimitView"
import {isEvTaxation} from "@/utils/CommonLogic";
import AltalanyPaidView from "../invoicing/AltalanyPaidView.vue";
import OwnerIdentification from "@/views/app/profile/OwnerIdentification.vue";
import TicketView from "../../../components/tickets/TicketView.vue";
import NewTicketModal from "../../../components/tickets/NewTicketModal.vue";


export default {
  name: "Home",
  components: {
    OwnerIdentification,
    AtalanyView,
    VatView,
    TaskView,
    PageHeader,
    AnnualLimit,
    AltalanyPaidView,
    TicketView,
    NewTicketModal
  },
  created() {
    this.getSelectedVatOption();
  },
  data() {
    return {
      hasNavConnection: undefined,
      isEvTaxation: isEvTaxation,
      vatViewEnabled: true,
      apiLoadingTask: true,
      tasks: [],
      tickets: [],
      myTaskOptions: {
        itemPerPage: 3,
        apiCallback: Api.getTasks,
        enablePagination: false,
        footerLink: {
          link: "/app/tasks",
          label: "home.allTasks",
        },
        detailView: "/app/task",
        displayProp: "title",
        backRouterLink: "/app/home",
      },
      myTicketOptions: {
        itemPerPage: 3,
        enablePagination: false,
        detailView: "/app/tickets",
        displayProp: "title",
        backRouterLink: "/app/home",
      },
      selectedTab: null,
      vatOptions: [
        {
          select: "vat.vatSelect",
          label: "vat.vat",
          value: "vat",
          description: "vat.taxForecast",
          caption: "vat.taxCaution",
        },
        {
          select: "vat.sumExcludedVatSelect",
          label: "vat.sumExcludedVat",
          value: "sumExcludedVat",
          description: "vat.sumExcludedVatForecast",
          caption: "vat.sumExcludedVatCaution",
        },
      ],
      atalanyOption: {
        select: "vat.atalany",
        label: "vat.atalany",
        value: "sumAtalany",
        description: "vat.atalany",
        caption: "vat.atalany",
      },
      apiLoadingTicket: true,
      forceUpdateKey: 0,
      quarters: [
        {
          "value": 0,
          "text": "I. negyedév"
        },
        {
          "value": 1,
          "text": "II. negyedév"
        },
        {
          "value": 2,
          "text": "III. negyedév"
        },
        {
          "value": 3,
          "text": "IV. negyedév"
        }
      ],
      selectedVatOption: null,
      showNewTicketModal: false,
      isLoading: false,
      isEvStatus: null,
      company: null,
    };
  },
  methods: {
    newTask() {
      window.open("https://www.messenger.com/t/acountoapp", "_blank");
    },

    newTicket() {
      this.showNewTicketModal = true;
    },
    hideTicketModal() {
      this.showNewTicketModal = false;
    },

    updateActiveTabId(tabIndex) {
      this.activeTabId = tabIndex
    },

    loadTasks(page, size) {
      this.apiLoadingTask = true;
      Api.getTasksWithPagination(page, size, this.getActiveCompany.id, true)
          .then((resp) => {
            this.tasks = resp.data;
            this.apiLoadingTask = false;
          })
          .catch(() => {
            this.$toast.error({
              title: 'Hiba',
              message: 'Értesítők betöltése sikertelen',
            });
          })
    },


    loadTickets(page, size) {
      this.apiLoadingTicket = true;
      Api.getTickets(page, size, this.getActiveCompany.id).then((resp) => {
        this.tickets = resp.data;
        this.apiLoadingTicket = false;
        this.forceUpdateKey++;
      })
    },
    confirmUpdate() {
      this.loadTickets(0, 3);
      this.forceUpdateKey++;
    },
    checkVat() {
      if (this.company.taxFrequencies.length === 0) {
        return true;
      } else {
        return (this.company.taxFrequencies[0].type !== 'NON_TAX');
      }
    },
    getSelectedVatOption() {
      if (this.isEvTaxation(this.getActiveCompany)) {
        this.selectedVatOption = this.atalanyOption;
      } else {
        this.selectedVatOption = this.vatOptions[0];
      }
    },
    async checkIsEvTaxation(company) {
      this.isLoading = true;
      try {
        const result = await isEvTaxation(company);
        this.isEvStatus = result;
        return result;
      } catch (error) {
        console.error('Error checking taxation status:', error);
        this.isEvStatus = false;
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    annualLimitTabIsShow(company){
      const hasNonTaxFrequency = Array.isArray(company?.taxFrequencies) &&
          company.taxFrequencies.some((taxFrequency) => taxFrequency.type === 'NON_TAX');
      const hasFlatRateTaxForm = Array.isArray(company?.taxForms) &&
          company.taxForms.some((taxForm) => taxForm.form === 'ATALANYADOZO');
      const cashFlowBaseVatCapInYears = company?.showCasFlowBaseVatCapInYears;
      const hasCashFlowBaseVatCapInYears = cashFlowBaseVatCapInYears != null &&
          cashFlowBaseVatCapInYears !== '' &&
          (!Array.isArray(cashFlowBaseVatCapInYears) || cashFlowBaseVatCapInYears.length > 0) &&
          (typeof cashFlowBaseVatCapInYears !== 'object' || Array.isArray(cashFlowBaseVatCapInYears) || Object.keys(cashFlowBaseVatCapInYears).length > 0);

      return hasNonTaxFrequency || hasFlatRateTaxForm || hasCashFlowBaseVatCapInYears;
    },

    loadCompany() {
      Api.getCompany(this.getActiveCompany.id).then((resp) => {
        this.company = resp.data;
      });
    }
  },
  mounted() {
    this.loadCompany();
    this.loadTasks(0, 3);
    this.loadTickets(0, 3);
    this.checkIsEvTaxation(this.getActiveCompany); // Call the method to check taxation status

    Api.navUserExists(this.getActiveCompany.id)
        .then((resp) => (this.hasNavConnection = resp.data))
        .catch(() => {
          this.$toast.error({
            title: this.$cte("Hiba"),
            message: this.$cte("Api hiba"),
          });
        });

    // Use the checkIsEvTaxation async method to properly determine tab selection
    this.checkIsEvTaxation(this.getActiveCompany).then(isEv => {
      if (isEv) {
        this.updateActiveTabId('my-custom-id-atalany');
      } else if (this.checkVat()) {
        this.updateActiveTabId('my-custom-id-vat');
      } else {
        this.updateActiveTabId('my-custom-id-sumExcludedVat');
      }
    });
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  watch: {
    showNewTicketModal() {
      this.loadTickets(0, 3);
    }
  },
  activeTabId() {
    const tabIds = [
      'my-custom-id-atalany',
      'my-custom-id-vat',
      'my-custom-id-sumExcludedVat',
    ];
    return this.selectedTab !== null ? tabIds[this.selectedTab] : 'None';
  },
};
</script>

<style scoped>
.custom-blur >>> .b-overlay div:first-child {
  opacity: 1 !important;
}

.green-select {
  background-color: #edf5ec !important;
  color: #5bb65d !important;
  border: none !important;
  height: 31px;
  width: 210px !important;
  float: right;
}

.empty-block {
  margin-left: 10px;
  padding-top: 25px;
  min-height: 100px;
}

.button-max-content {
  width: max-content !important;
}

.new-ticket-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0 !important;
  font-size: 14px;
}

.new-ticket-button .fa-plus {
  line-height: 1;
  transform: translateY(-1px);
}

.home-view-container {
  min-height: 357px;
}

.my-md-3 {
  margin-top: 1rem;
}

@media (min-width: 768px) {
  .my-md-3 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (max-width: 768px) {
  .reportSliderContainer {
    font-size: smaller !important;
  }
}
</style>
